import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';

import {fetchUserIdentityData} from '../../dataFetchers/noAuthDataFetcher'
import { Configuration } from "../../configs/Configuration";
import { parseQueryParams } from '../../helpers/URLHelper';
import {setUserHash} from '../../actions/userDataActions';
import { currentAuthToken } from '../../helpers/authHelper'
import Widget from '../../components/widgets/Widget';
import BCLLoading from '../../components/common/Loading/BCLLoading';
import Unauthorized from '../../components/common/Error/Unauthorized/Unauthorized';
import { bidgelyStorage } from '../../helpers/storageHelper';

class WidgetAuthenticationLayer extends React.Component{
    configuration = Configuration.getConfiguration();

    componentDidMount(){
        let options={
            "pilot-id" : this.configuration.pilotId,
            "client-id" : this.configuration.clientId
        }
        let userHash = null;
        if(this.props.location.search !== ""){
           let parsedString = parseQueryParams(this.props.location.search);
            if (parsedString['user-hash']) {
                userHash = parsedString['user-hash'];
                bidgelyStorage.setItem('userHash', userHash);
            }
        }
        userHash = bidgelyStorage.getItem('userHash');
        this.props.setUserHash(userHash);
        this.props.fetchUserIdentityData(userHash, options);
    }

    render(){
        return(
            <>
                {this.props.userHash.userHashExpired ?
                    <Unauthorized />
                :
                    ((currentAuthToken !== null) && (this.props.userIdentityDetails !== null) ? <Route component={Widget} /> : <BCLLoading />)}
            </>
        )
    }
}

const mapStateToProps = state => {
    return{
        userIdentityDetails : state.userIdentityDetails,
        userHash : state.userHash
    }
}

const mapDispatchToProps = dispatch => {
    return{
        setUserHash : (userHash) => dispatch(setUserHash(userHash)),
        fetchUserIdentityData : (userHash, options) => dispatch(fetchUserIdentityData(userHash, options))
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(WidgetAuthenticationLayer);
